var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_LOAD_STATE } from 'globals/enums';
import { GET_DEVICES_LIST, GET_DEVICES_LIST_SUCCESS, GET_DEVICES_LIST_FAIL, GET_DEVICES_SEARCH_LIST_SUCCESS, UPDATE_DEVICES_LIST_PAGE_NUMBER, RESET_DEVICES_LIST, SET_DEVICE_TYPE_VALUE, SET_DEVICE_SEARCH_QUERY, } from './DeviceInfo.action';
export var INITIAL_STATE = {
    data: [],
    searchLastEvaluatedKey: '',
    loading: API_LOAD_STATE.NOT_LOADED,
    currentPage: 1,
    searchQuery: '',
    deviceType: '',
    lastEvaluatedKey: '',
};
export var deviceReducerAdmin = function (state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case GET_DEVICES_LIST:
            return __assign(__assign({}, state), { loading: API_LOAD_STATE.PROGRESS });
        case GET_DEVICES_LIST_SUCCESS:
            return __assign(__assign({}, state), { loading: API_LOAD_STATE.SUCCESSFUL, data: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.data) || [], searchLastEvaluatedKey: '' });
        case GET_DEVICES_SEARCH_LIST_SUCCESS:
            return __assign(__assign({}, state), { loading: API_LOAD_STATE.SUCCESSFUL, data: ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.data) || [], searchLastEvaluatedKey: ((_c = action.payload) === null || _c === void 0 ? void 0 : _c.searchLastEvaluatedKey) || '', searchQuery: ((_d = action.payload) === null || _d === void 0 ? void 0 : _d.searchQuery) || state.searchQuery });
        case GET_DEVICES_LIST_FAIL:
            return __assign(__assign({}, state), { loading: API_LOAD_STATE.ERROR });
        case UPDATE_DEVICES_LIST_PAGE_NUMBER:
            return __assign(__assign({}, state), { currentPage: action.payload });
        case SET_DEVICE_TYPE_VALUE:
            return __assign(__assign({}, state), { deviceType: action.payload });
        case SET_DEVICE_SEARCH_QUERY:
            return __assign(__assign({}, state), { searchQuery: action.payload });
        case RESET_DEVICES_LIST:
            return __assign({}, INITIAL_STATE);
        default:
            return state;
    }
};
